// CFIs who can't fly discovery flights. Empty: every approved CFI is a named pilot
// on the aircraft policy (Casey, 10/26/26: Adam included).
export const NO_DISCOVERY_EMAILS: string[] = [];
